/**
 * @flow
 * @relayHash ba6ff28d80aea0b7fd7dca98ca3c90fb
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type GLAccountType = "ASSET" | "COGS" | "EQUITY" | "EXPENSE" | "LIABILITY" | "REVENUE";
export type AddJournalEntryModalQueryVariables = {||};
export type AddJournalEntryModalQueryResponse = {|
  +glAccounts: {|
    +edges: ?$ReadOnlyArray<?{|
      +node: {|
        +id: string,
        +accountNumber: string,
        +name: string,
        +accountType: GLAccountType,
      |}
    |}>
  |}
|};
export type AddJournalEntryModalQuery = {|
  variables: AddJournalEntryModalQueryVariables,
  response: AddJournalEntryModalQueryResponse,
|};
*/


/*
query AddJournalEntryModalQuery {
  glAccounts(first: 200, isActive: true, sortBy: {field: ACCOUNT_NUMBER, direction: ASC}) {
    edges {
      node {
        id
        accountNumber
        name
        accountType
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "glAccounts",
    "storageKey": "glAccounts(first:200,isActive:true,sortBy:{\"direction\":\"ASC\",\"field\":\"ACCOUNT_NUMBER\"})",
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 200
      },
      {
        "kind": "Literal",
        "name": "isActive",
        "value": true
      },
      {
        "kind": "Literal",
        "name": "sortBy",
        "value": {
          "direction": "ASC",
          "field": "ACCOUNT_NUMBER"
        }
      }
    ],
    "concreteType": "GLAccountConnection",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "GLAccountEdge",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "GLAccount",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "accountNumber",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "name",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "accountType",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "AddJournalEntryModalQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "AddJournalEntryModalQuery",
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "AddJournalEntryModalQuery",
    "id": null,
    "text": "query AddJournalEntryModalQuery {\n  glAccounts(first: 200, isActive: true, sortBy: {field: ACCOUNT_NUMBER, direction: ASC}) {\n    edges {\n      node {\n        id\n        accountNumber\n        name\n        accountType\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '78c2fad5d05e191ded39463f715fc189';
module.exports = node;
